/**
 * Wallet failures used to surface as an unhandled rejection in the console and nothing at all on
 * screen -- the button simply stopped spinning. Every path that can fail now runs its error
 * through here so the player is told which of the three very different things went wrong: they
 * declined, the wallet is not reachable, or our backend rejected the proof.
 */

/** The wallet extension's own code for "the user clicked Reject". */
const USER_REJECTED = 4001

const isRejection = (error: any) => {
    if (error?.code === USER_REJECTED || error?.error?.code === USER_REJECTED) return true
    const message = String(error?.message ?? '').toLowerCase()
    return message.includes('user rejected') || message.includes('user denied') || message.includes('declined')
}

export const describeWalletError = (error: any): string => {
    if (isRejection(error)) return 'Request declined in your wallet.'

    switch (error?.name) {
        case 'WalletNotReadyError':
        case 'WalletNotSelectedError':
            return 'Wallet not detected. Make sure it is installed and unlocked, then reload this page.'
        case 'WalletConnectionError':
            return 'Could not connect to the wallet. Unlock it and try again.'
        case 'WalletSignMessageError':
        case 'WalletSignTransactionError':
            return 'The wallet could not sign. If you are using a hardware wallet, unlock it and open the Solana app.'
        case 'WalletTimeoutError':
            return 'The wallet did not respond in time. Try again.'
    }

    return error?.message || 'Something went wrong talking to your wallet.'
}
